import type { PensionAsset } from "~/types/assets.types";

export const calculatePensionYears = (userProduct: PensionAsset) => {
  const fundOpeningDate = userProduct?.fundOpeningDate || "";
  const currentDate = new Date();
  const openingDate = new Date(fundOpeningDate);

  return currentDate.getFullYear() - openingDate.getFullYear() || 0;
};
